import React, { useEffect, useState } from "react";
import { FaRegStar } from "react-icons/fa";
import { useParams } from "react-router";
import { RiDeleteBin6Line } from "react-icons/ri";
import { VscTerminalLinux } from "react-icons/vsc";
import { getData } from "../../../api/method";

function TableReview({ args, getReviewByDel }) {
  const [data, setData] = useState([]);

  const { id } = useParams();

  const getReview = async () => {
    try {
      const result = await getData(`/api/Review/list/${id}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReview();
  }, [data]);

  return (
    <div className="border_top mt-3">
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="mt-3">
            <div className="d-flex justify-content-between mt-2">
              <div className="d-flex review_star mb-2">
                <FaRegStar />
                <FaRegStar />
                <FaRegStar />
                <FaRegStar />
                <FaRegStar />
              </div>

              <div className="d-flex fs-15">
                <span>{item.date.slice(0, 10)}</span>
              </div>
            </div>

            <div className="d-flex align-items-end">
              <p className="fs-20 t-primary">
                {item.user.lastname} {item.user.firstname}
              </p>
              <p className="ms-3 t-grey fs-6 t-capitalize">
                {item.product.name}
              </p>
            </div>

            <p className="review_text my-2">{item.comment}</p>

            <div
              className="d-flex align-items-end justify-content-end cursor_pointer"
              onClick={() => getReviewByDel(item.id)}
            >
              <RiDeleteBin6Line />
              <span className="ms-1 t-grey">Xóa</span>
            </div>
          </div>
        ))
      ) : (
        <div className="d-flex py-4 flex-column align-items-center">
          <VscTerminalLinux className="fs-2" />
          <p className="fs-20 pt-2">No Review</p>
        </div>
      )}
    </div>
  );
}

export default TableReview;
